import actionTypes from "../webActionTypes";

const reducers = {
    [actionTypes.beginGetTurnkeyUploadLogList]: function (state, action) {
      return beginGetTurnkeyUploadLogList(state, action);
    },
    [actionTypes.recvGetTurnkeyUploadLogListResult]: function (state, action) {
      return recvGetTurnkeyUploadLogListResult(state, action);
    },
    [actionTypes.recvGetTurnkeyUploadLogListError]: function (state, action) {
      return recvGetTurnkeyUploadLogListError(state, action);
    },
    [actionTypes.finishGetTurnkeyUploadLogYearmonthList]: function (state, action) {
      return finishGetTurnkeyUploadLogYearmonthList(state, action);
    },
};

export default function createReducers(initialState) {

    return function reducer(state = initialState, action) {
        if (reducers.hasOwnProperty(action.type)) {
            return reducers[action.type](state, action);
        } else {
            return state;
        }
    };
}

function beginGetTurnkeyUploadLogList(state, action) {

    if (state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isGetTurnkeyUploadLogList: true
    });
}

function recvGetTurnkeyUploadLogListResult(state, action) {

    const {
        payload
    } = action;

    const {totalCount, querykey, ids, data} = payload;

    if (ids.length === 0) {
        return state;
    }
    
    var turnkeyUploadLogList;

    if(querykey === state.querykey) {
        turnkeyUploadLogList = Object.assign({}, state.turnkeyUploadLogList, ids);        
    } else {
        turnkeyUploadLogList = Object.assign({}, {}, ids);
    }

    const turnkeyUploadLogs = Object.assign({}, state.turnkeyUploadLogs, data);

    return Object.assign({}, state, {
        turnkeyUploadLogList,
        turnkeyUploadLogs,
        totalCount,
        querykey,
        isGetTurnkeyUploadLogList: false,
    });
}


function recvGetTurnkeyUploadLogListError(state, action) {
	
    if (!state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isGetTurnkeyUploadLogList: false
    });
}

function finishGetTurnkeyUploadLogYearmonthList(state, action) {

    const payload = action.payload;
    const yearmonthList = payload.yearmonthList || [];

    return Object.assign({}, state, {
        yearmonthList: yearmonthList,
    });
}


// WEBPACK FOOTER //
// ./src/actions/reducers/turnkeyUploadLogReducers.js